module.exports = __webpack_public_path__ + "static/media/setup-crmLogo.4129c784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setup-crmLogo.png
// module id = 1835
// module chunks = 3